<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :loading='loading'>
            <el-form-item label="公众号" prop="gzh_value">
                <el-select v-model="ruleForm.gzh_value" size="small" placeholder="请选择" @change="gzhchange">
                    <el-option v-for="item in ruleForm.gzh_options" :key="item.source" :label="item.name" :value="item.source">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Token" prop="token">
                <el-input v-model="ruleForm.token" size="small"></el-input>
            </el-form-item>
            <el-form-item label="AppId" prop="appid">
                <el-input v-model="ruleForm.appid" size="small"></el-input>
            </el-form-item>
            <el-form-item label="AppSecret" prop="appsecret">
                <el-input v-model="ruleForm.appsecret" size="small"></el-input>
            </el-form-item>
            <el-form-item label="EnAesKey" prop="enaeskey">
                <el-input v-model="ruleForm.enaeskey" size="small"></el-input>
            </el-form-item>
            <el-form-item label="授权IP" prop="sqid">
                <el-input v-model="ruleForm.sqid" size="small"></el-input>
            </el-form-item>
            <el-form-item label="推送地址" prop="name">
                <el-input v-model="ruleForm.url" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submitForm('ruleForm')">立即提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading:false,
                ruleForm: {
                    gzh_value: 'wechat',
                    gzh_options: [{
                        id: 'wechat',
                        name: '快康健康'
                    }, {
                        id: 'wechat_kkcm',
                        name: '快康传媒'
                    }],
                    token: '',
                    appid: '',
                    appsecret: '',
                    enaeskey: '',
                    sqid: '',
                    url: '',
                },
                rules: {
                    gzh_value: [{
                        required: true,
                        message: '请选择公众号',
                        trigger: 'blur'
                    }],
                    token: [{
                        required: true,
                        message: '请填写Token',
                        trigger: 'blur'
                    }],
                    appid: [{
                        required: true,
                        message: '请填写AppId',
                        trigger: 'blur'
                    }],
                    appsecret: [{
                        required: true,
                        message: '请填写AppSecret',
                        trigger: 'blur'
                    }],
                    enaeskey: [{
                        required: true,
                        message: '请填写enaeskey',
                        trigger: 'blur'
                    }],
                    sqid: [{
                        required: true,
                        message: '请填写授权ip',
                        trigger: 'blur'
                    }]
                }
            }
        },
        mounted() {
            this.getselects()
            this.getxx()
        },
        methods: {
             // 获取下拉框
            getselects() {
                axios.post('/admin/wechat.index/gzhConfig', {}, {
                    token: true
                }).then(res => {
                    if (res.data.data) {
                        this.ruleForm.gzh_options = res.data.data.filter(a=>a.appid!='wx10dde7d68a3a2239')
                        this.ruleForm.gzh_value = res.data.data[0].source
                    } else {
                        this.ruleForm.gzh_options = []
                    }
                }).catch(err => {})
            },
            getxx() {
                this.loading=true
                axios
                    .post("/admin/wechat.index/api", {
                        source: this.ruleForm.gzh_value
                    }, {
                        token: true
                    })
                    .then(response => {
                         this.loading=false
                        var data = response.data.data
                        this.ruleForm.appid = data.appid
                        this.ruleForm.appsecret = data.appsecret
                        this.ruleForm.enaeskey = data.enaes_key
                        this.ruleForm.sqid = data.ip
                        this.ruleForm.token = data.token
                        this.ruleForm.url = data.url
                    })
                    .catch(error => {})
            },
            gzhchange() {
                this.getxx()
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/wechat.index/api", {
                                source: this.ruleForm.gzh_value,
                                op: 'edit',
                                token: this.ruleForm.token,
                                appid: this.ruleForm.appid,
                                appsecret: this.ruleForm.appsecret,
                                enaes_key: this.ruleForm.enaeskey,
                                ip: this.ruleForm.sqid,
                            }, {
                                token: true
                            })
                            .then(response => {
                                this.$message('操作成功')
                                 this.getxx()
                            })
                            .catch(error => {})

                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style>

</style>